import { SectionHeading, FadeUp } from "./Reveal";

const FAQS = [
  {
    q: "What does JIYONOX do?",
    a: "JIYONOX is an AI consulting, software engineering and cloud technology company. We design, build and operate intelligent digital systems — custom software, AI agents and agentic AI workflows, business automation, cloud-native platforms and enterprise digital experiences — for enterprises, startups, associations, healthcare organizations and commerce brands.",
  },
  {
    q: "What is agentic AI, and how does it help my business?",
    a: "Agentic AI goes beyond chatbots that answer questions. AI agents understand context, use tools, connect to your CRM, ERP, email, calendar and databases, and execute real work — processing documents, qualifying leads, scheduling, reporting and resolving support requests. JIYONOX architects these systems with governance, human approval points and observability so automation stays safe and measurable.",
  },
  {
    q: "Can JIYONOX work with the systems we already use?",
    a: "Yes. Our AI development and workflow automation practice is built around integration. We connect intelligent agents and automation to existing business systems through APIs — including CRM and ERP platforms, document stores, marketing technology, data warehouses and analytics tools — so intelligence layers onto your current stack rather than replacing it.",
  },
  {
    q: "How does JIYONOX handle cloud engineering and reliability?",
    a: "We build and operate cloud-native systems on AWS, Azure and Google Cloud using Docker, Kubernetes, microservices and serverless architectures. Our managed operations cover DevOps, CI/CD, monitoring, security, backups, performance optimization and reliability engineering — so critical digital systems stay secure, observable and continuously improving.",
  },
  {
    q: "What is included in your digital experience services?",
    a: "Our digital experience practice covers Adobe Experience Manager (AEM consulting), digital asset management, content supply chain modernization, personalization, commerce integrations, customer data platforms, search, analytics and SEO automation. We help enterprises turn content platforms into intelligent experience engines that adapt and improve on their own.",
  },
  {
    q: "What does an engagement with JIYONOX look like?",
    a: "Every engagement follows four stages: Discover (goals, users, systems, opportunities), Design (architecture, experience, AI, data and workflow design), Build (engineering, integration, automation, deployment) and Operate & Grow (monitoring, optimization and continuous evolution). Whether it is a SaaS development program, a digital transformation initiative or a single intelligent workflow, the process stays the same — business outcomes first, technology second.",
  },
  {
    q: "Does JIYONOX only consult, or do you actually build products?",
    a: "We build. JIYONOX is an engineering company first: our teams ship production software — SaaS platforms, enterprise portals, mobile-responsive applications, commerce systems and AI products — and then operate what we build. Strategy and architecture matter, but every engagement ends in working, deployed systems, not slide decks.",
  },
  {
    q: "How do you keep AI systems secure and governable?",
    a: "Every AI system we design includes access control, audit trails, evaluation harnesses and human approval points for sensitive actions. Enterprise AI at JIYONOX means systems that are secure, scalable, governable and measurable from the first prototype — not retrofitted after an incident.",
  },
  {
    q: "Can you take over or modernize a platform another vendor built?",
    a: "Yes. A large part of our work is modernization: inheriting existing applications, stabilizing infrastructure, migrating to cloud-native architectures, and layering in automation and AI. We start with a technical assessment, document what exists, and then improve the platform incrementally without disrupting your operations.",
  },
  {
    q: "How do we start, and what does it cost?",
    a: "Every engagement begins with a discovery conversation — tell us what you are trying to build, improve or automate, and we will map the opportunity to a concrete architecture and scope. Pricing follows the shape of that solution, so you always know what you are paying for and why. Start a conversation at hello@jiyonox.com.",
  },
];

export const Faq = () => (
  <section data-testid="faq-section" className="py-24 sm:py-32 bg-jx-mist">
    <div className="max-w-7xl mx-auto px-6 lg:px-8 grid lg:grid-cols-12 gap-12">
      <div className="lg:col-span-4">
        <SectionHeading
          testId="faq"
          overline="Questions, Answered"
          title={<>Everything you need to <span className="jx-gradient-text">know.</span></>}
          body="Straight answers about how JIYONOX works, what we build and how an engagement starts."
        />
      </div>
      <div className="lg:col-span-8 flex flex-col gap-3">
        {FAQS.map((f, i) => (
          <FadeUp key={f.q} delay={i * 0.06}>
            <details
              data-testid={`faq-item-${i}`}
              className="group rounded-2xl bg-white border border-jx-ink/8 px-7 py-5 open:border-jx-purple/25 open:shadow-[0_12px_36px_rgb(0,0,0,0.06)] transition-[border-color,box-shadow] duration-300"
            >
              <summary className="flex items-center justify-between gap-6 cursor-pointer list-none font-display font-bold text-lg tracking-tight text-jx-ink [&::-webkit-details-marker]:hidden">
                {f.q}
                <span className="shrink-0 w-8 h-8 rounded-full bg-jx-mist flex items-center justify-center text-jx-purple text-xl font-body font-medium transition-transform duration-300 group-open:rotate-45 group-open:jx-gradient-bg group-open:text-white">+</span>
              </summary>
              <p className="mt-4 text-base leading-relaxed text-jx-ink/65 pr-10">{f.a}</p>
            </details>
          </FadeUp>
        ))}
      </div>
    </div>
  </section>
);
